import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    function setActivityTimestamp() {
      localStorage.setItem('lastActivity', Date.now().toString());
    }
    
    document.addEventListener('click', setActivityTimestamp);
    document.addEventListener('keydown', setActivityTimestamp);
    document.addEventListener('mousemove', setActivityTimestamp);
    
    function checkActivity() {
      const lastActivity = localStorage.getItem('lastActivity');
      if (lastActivity) {
          const currentTime = Date.now();
          const elapsed = currentTime - parseInt(lastActivity);
          console.log(lastActivity,currentTime,elapsed);
    
          const maxInactiveTime = 15 * 60 * 1000; // 15 minutes in milliseconds
          if (elapsed > maxInactiveTime) {
              localStorage.clear();
              console.log('Local storage cleared due to inactivity.');
              setIsAuthenticated(false);
          }
      }
    }
    
    // Check every minute
    const intervalId = setInterval(checkActivity, 60 * 1000);
    
    document.addEventListener('DOMContentLoaded', () => {
      setActivityTimestamp(); // Set initial timestamp
      checkActivity(); // Check immediately on load
    });

    // Check authentication status immediately
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
    } else {
      // Additional token validation could be added here
      setIsAuthenticated(true);
    }

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('click', setActivityTimestamp);
      document.removeEventListener('keydown', setActivityTimestamp);
      document.removeEventListener('mousemove', setActivityTimestamp);
    };
  }, []);

  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50 dark:bg-zink-800">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500 mx-auto"></div>
          <p className="mt-2 text-slate-600 dark:text-zink-200">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={{ pathname: "/login" }} replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
